import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Section from '../components/Section.jsx';

const Bijaipur = () => (
  <div id="page">
    <Header
      plain
      title="Bijaipur"
      kicker="Near by · Mewar"
      tagline="The estate seat, its palace hotels, and the sixty villages that still look to it."
    />

    <Section eyebrow="Brief" title="Bijaipur">
      <div className="intro intro--with-figure">
        <div className="prose prose--lead reveal">
          <p>
            Bijaipur mevar rehasat ki ek ekai hai. Vartaman mai Rav Narendra
            Shih iske raja hai. Is ravale ke adhin 60 gaav aate hai. In gaavo ke
            log aaj bhi inhe aapna raja mante hai tatha usi tarah samaan bhi
            karate hai.
          </p>
          <p>
            Yaha par do (2) 3-sitara hotele hai — Hotel Castel aur Hotel Pratap
            Palace. Yaha par verse bhar videsi paryatak aate hai. Paangarh bandh
            bhi isi ravle ke under aata hai; vaha par bhi ek (1) hotel ki
            sthapana ki gayi hai jiska sanchalan Rav Narendra Shih dwara kiya
            jata hai.
          </p>
          <p>
            Bijaipur mai &ldquo;Motidasji ki mandi&rdquo; ka sanchalan 60 gaavo
            ke gramino dwara kiya jata hai. Isi tarah Narsing dware ka sanchalan
            Bijaipur ke gramino dwara kiya jata hai.
          </p>
        </div>
        <figure className="figure reveal">
          <img
            src="/images/about/amarpura2.JPG"
            alt="Rooftops on the hillside near Bijaipur"
            width="448"
            height="336"
          />
          <figcaption>The hillside villages of the Bijaipur estate.</figcaption>
        </figure>
      </div>
    </Section>

    <Section narrow tint title="Also near by">
      <ul className="facts reveal">
        <li>
          <a href="/paangarh">Paangarh</a> &mdash; the lake, 12 km north
        </li>
        <li>
          <a href="/modiya-mahadev">Modiya Mahadev</a> &mdash; hilltop temple
          and ashram
        </li>
      </ul>
    </Section>

    <Footer />
  </div>
);

export default Bijaipur;
